/* Flash Detail – cod MINI: prosop mini cadou adăugat automat în coș (min 100 lei) */
(function () {
  var GIFT = 57439807439113;          // variant "Prosop Uscare Mini - CADOU"
  var CODE = 'MINI';
  var MIN = 10000;                    // 100,00 lei în bani
  var busy = false, pending = false, internal = false, timer = null;
  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function getCart() { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function post(url, body) { internal = true; return fetch(url, { method: 'POST', headers: H, body: JSON.stringify(body) }).finally(function () { internal = false; }); }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  function state(c) {
    var gifts = c.items.filter(function (i) { return i.variant_id === GIFT; });
    var qty = gifts.reduce(function (s, i) { return s + i.quantity; }, 0);
    var sub = c.items.filter(function (i) { return i.variant_id !== GIFT; }).reduce(function (s, i) { return s + i.original_line_price; }, 0);
    var code = (c.discount_codes || []).filter(function (d) { return (d.code || '').toUpperCase() === CODE; })[0];
    return { gifts: gifts, qty: qty, sub: sub, code: code, eligible: !!code && sub >= MIN };
  }

  function rerender() {
    if (onCartPage()) { location.reload(); return Promise.resolve(); }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var p = new DOMParser();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && s['cart-drawer']) {
        var n = p.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        var cur = document.getElementById('CartDrawer');
        if (n && cur) {
          cur.innerHTML = n.innerHTML;
          var inner = drawer.querySelector('.drawer__inner');
          if (inner && !drawer.classList.contains('is-empty')) inner.classList.remove('is-empty');
          var ov = drawer.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', function () { drawer.close(); });
        }
      }
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) {
        var bn = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bn) b.innerHTML = bn.innerHTML;
      }
    }).catch(function () {});
  }

  function mark(c) {
    document.querySelectorAll('.fd-gift').forEach(function (e) { e.classList.remove('fd-gift'); });
    c.items.forEach(function (it, i) {
      if (it.variant_id !== GIFT) return;
      ['#CartDrawer-Item-' + (i + 1), '#CartItem-' + (i + 1)].forEach(function (sel) {
        var row = document.querySelector(sel); if (row) row.classList.add('fd-gift');
      });
    });
    var st = state(c);
    document.querySelectorAll('[data-fd-code]').forEach(function (box) {
      var applied = box.querySelector('[data-fd-applied]');
      var form = box.querySelector('[data-fd-form]');
      if (st.eligible) {
        if (applied) { applied.hidden = false; applied.querySelector('[data-fd-code-name]').textContent = st.code.code; }
        if (form) form.hidden = true;
        msg(box, 'Prosopul mini cadou este în coș.', true);
      } else {
        if (applied) applied.hidden = true;
        if (form) form.hidden = false;
        if (st.code && st.sub < MIN) msg(box, 'Codul MINI este activ: mai adaugă produse până la 100 lei și prosopul mini cadou apare automat în coș.', false);
      }
    });
  }

  function sync() {
    if (busy) { pending = true; return Promise.resolve(); }
    busy = true;
    return getCart().then(function (c) {
      var st = state(c), changed = false, p = Promise.resolve();
      if (st.eligible && st.qty !== 1) {
        changed = true;
        if (st.qty === 0) p = post('/cart/add.js', { items: [{ id: GIFT, quantity: 1, properties: { _cadou: 'MINI' } }] });
        else p = post('/cart/change.js', { id: st.gifts[0].key, quantity: 1 });
      } else if (!st.eligible && st.qty > 0) {
        changed = true;
        st.gifts.forEach(function (l) { p = p.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); });
      }
      return p.then(function () {
        if (!changed) return c;
        // verificare: cadoul trebuie sa fie 0 lei (reducerea MINI aplicata); altfel il scoatem
        return getCart().then(function (c2) {
          var bad = c2.items.filter(function (i) { return i.variant_id === GIFT && i.final_line_price > 0; });
          if (!bad.length) return c2;
          var q = Promise.resolve();
          bad.forEach(function (l) { q = q.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); });
          return q.then(getCart);
        }).then(function (c3) { return rerender().then(function () { return c3; }); });
      }).then(mark);
    }).catch(function () {}).then(function () {
      busy = false;
      if (pending) { pending = false; return sync(); }
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 250); }

  // orice modificare a coșului făcută de temă sau de alte aplicații
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = _fetch.apply(this, arguments);
    if (!internal && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) res.then(schedule, function () {});
    return res;
  };
  var _send = XMLHttpRequest.prototype.send, _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this._fdUrl = u; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(this._fdUrl || '')) this.addEventListener('loadend', schedule);
    return _send.apply(this, arguments);
  };

  function msg(box, text, ok) {
    var m = box.querySelector('[data-fd-msg]'); if (!m) return;
    m.textContent = text; m.hidden = !text; m.classList.toggle('is-ok', !!ok);
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-fd-apply]');
    var remove = e.target.closest('[data-fd-remove]');
    if (!apply && !remove) return;
    e.preventDefault();
    var box = e.target.closest('[data-fd-code]'); if (!box) return;
    if (remove) {
      post('/cart/update.js', { discount: '' }).then(function () { msg(box, '', false); return sync(); });
      return;
    }
    var input = box.querySelector('input'); var code = (input.value || '').trim().toUpperCase();
    if (!code) { msg(box, 'Scrie codul de reducere.', false); return; }
    apply.disabled = true;
    post('/cart/update.js', { discount: code }).then(function (r) { return r.json(); }).then(function (c) {
      var d = (c.discount_codes || []).filter(function (x) { return (x.code || '').toUpperCase() === code; })[0];
      var st = state(c);
      if (d && (code === CODE ? st.sub >= MIN : d.applicable)) {
        msg(box, code === CODE ? 'Cod aplicat. Prosopul mini cadou a fost adăugat în coș.' : 'Cod aplicat.', true);
        input.value = '';
      } else if (code === CODE) {
        msg(box, 'Codul MINI e valabil la comenzi de minim 100 lei. Mai adaugă produse și prosopul mini cadou apare automat.', false);
      } else {
        msg(box, 'Codul nu este valabil pentru produsele din coș.', false);
      }
      return sync();
    }).catch(function () { msg(box, 'Nu am putut aplica codul. Încearcă din nou.', false); })
      .then(function () { apply.disabled = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-fd-code] input')) { e.preventDefault(); var b = e.target.closest('[data-fd-code]').querySelector('[data-fd-apply]'); if (b) b.click(); }
  });

  var icon = document.getElementById('cart-icon-bubble');
  if (icon) icon.addEventListener('click', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
